import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";

export const MarkdownRenderer = ({ className, markdown }) => {
  const renderers = {
    h1: ({ children }) => (
      <h1 className="tbk-text-h3-subtitle lg:tbk-text-h2-black tbk-text-primary">
        {children}
      </h1>
    ),
    h2: ({ children }) => (
      <h2 className="tbk-text-h2-black lg:tbk-text-title-bold tbk-text-primary">
        {children}
      </h2>
    ),
    h3: ({ children }) => (
      <h3 className="tbk-text-h3-subtitle tbk-my-2 tbk-text-primary">
        {children}
      </h3>
    ),
    // Custom renderer for paragraphs
    p: ({ children }) => (
      <p className="tbk-text-main tbk-mb-2 tbk-text-primary">{children}</p>
    ),
    a: ({ children, ...props }) => (
      <a
        className="tbk-text-blue tbk-underline hover:tbk-text-blue-light hover:tbk-underline"
        {...props}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    ),
    // Custom renderer for line breaks
    br: () => <br />,
    strong: ({ children }) => (
      <span className="tbk-font-bold tbk-text-primary">{children}</span>
    ),
    ul: ({ children }) => (
      <ul className="tbk-my-2 tbk-list-disc tbk-pl-5">{children}</ul>
    ),
    ol: ({ children }) => (
      <ol className="tbk-my-2 tbk-list-decimal tbk-pl-5">{children}</ol>
    ),
    li: ({ children }) => <li className="tbk-my-1">{children}</li>,
    blockquote: ({ children }) => (
      <blockquote className="tbk-my-2 tbk-border-l-4 tbk-border-blue-grey-light tbk-pl-4 tbk-italic">
        {children}
      </blockquote>
    ),
  };

  return (
    <ReactMarkdown
      components={renderers}
      remarkPlugins={[remarkGfm, remarkBreaks]}
    >
      {markdown}
    </ReactMarkdown>
  );
};

export default MarkdownRenderer;
